const metaData = {
  fields: [
    'id',
    'work_request_id',
    'reviewer_stem_comments',
    'approver_stem_comments',
    'retire_by_auto_rules',
    'parent_question_id',
    'question_insight',
    'status',
    'source',
    'second_reviewer_id',
    'second_approver_id',
    'second_reviewer_comments',
    'second_approver_comments',
    'source',
    'reference_data_id',
    'language',
    'transilation_of',
    'variant_of',
    {questionByTransilationOf:['title','id','question_id','option_details']},
    { parent_child_question_reference_data: ['id', 'reference_data'] },
    { parent_question: ['id', 'question_id', 'title'] },
    {
      work_request: [
        'id',
        'name',
        'request_id',
        'request_type',
        'status',
        'created_by',
        ,
        { topic: ['name'] },
        'subject_id',
        { subject: ['name'] },
        'theme_id',
        { theme: ['name'] },
        'sub_theme_id',
        { sub_theme: ['name'] },
        'report_theme_id',
        { report_theme: ['name'] },
        'question_type_id',
        { question_type: ['name'] },
        'teacher_level_id',
        { teacher_level: ['name'] },
        'bloom_level_id',
        { bloom_level: ['name'] },
        'difficulty_level_id',
        { difficulty_levels: ['name'] },
        'centa_standard_id',
        { centa_standard: ['name'] },
        'strand_id',
        { strands: ['name'] },
        { taxonomy: ['id', 'name'] },
        'competency_id',
        { competencies: ['name'] },

        { workRequestGrades: ['id', 'grade_id', { grade: ['name'] }] },
        { userByCreatorId: ['id', 'displayName'] },
        { workRequestReviewers: ['id', 'user_id', { userByReviewerId: ['displayName', 'id'] }] },
        {
          workRequestApprovers: [
            'id',
            'approver_id',
            { userByApprover: ['displayName', 'id'] },
            'reviewer_id',
            { userByReviewerId: ['displayName', 'id'] },
          ],
        },
        // { userByReviewerId: ['id', 'displayName'] }, { userByApproverId: ['id', 'displayName'] }
      ],
    },
    'description',
    'title',
    'question',
    'question_type_id',
    'request_type',
    'user_type',
    'active',
    { question_type: ['name'] },
    'explanation_type_id',
    { explanation_type: ['name'] },
    'grade_id',
    { grade: ['name'] },
    'subject_id',
    { subject: ['name'] },
    'theme_id',
    { theme: ['name'] },
    'sub_theme_id',
    { sub_theme: ['name'] },
    'report_theme_id',
    { report_theme: ['name'] },
    'topic_id',
    { topic: ['name'] },

    'creator_id',
    { userByCreatorId: ['displayName'] },
    'reviewer_id',
    { userByReviewerId: ['displayName'] },
    'approver_id',
    { userByApproverId: ['displayName'] },
    'question_id',
    'status',
    'option_details',
    'option_type',
    'teacher_level_id',
    { teacher_level: ['name'] },
    'bloom_level_id',
    { bloom_level: ['name'] },
    'difficulty_level_id',
    { difficulty_level: ['name'] },
    'competency_id',
    { competencies: ['name'] },
    // 'competency_aspect_id',
    // { competency_aspect: ['name'] },
    'centa_standard_id',
    { centa_standard: ['name'] },
    'strand_id',
    { strand: ['name'] },
    'centa_concept_id',
    { centa_concept: ['name'] },
    'tn_taxonomy_id',
    { tn_taxonomy: ['name'] },
    'created_at',
    'created_by',
    { user: ['displayName'] },
    'updated_at',
    'updated_by',
    'mark_retired_reasons',
    'mark_retired_comments',
    'grade_ids',
    'custom_tag',
    { question_grades: ['id', 'grade_id', { grade: ['name'] }] },
    // {
    //   paper_work_request: [
    //     'name',
    //     'request_id',
    //     'request_type',
    //     'status',
    //     { topic: ['name'] },
    //     'subject_id',
    //     { subject: ['name'] },
    //     'theme_id',
    //     { theme: ['name'] },
    //     'sub_theme_id',
    //     { sub_theme: ['name'] },
    //     'report_theme_id',
    //     { report_theme: ['name'] },
    //     'question_type_id',
    //     { question_type: ['name'] },
    //     'teacher_level_id',
    //     { teacher_level: ['name'] },
    //     'bloom_level_id',
    //     { bloom_level: ['name'] },
    //     'difficulty_level_id',
    //     { difficulty_level: ['name'] },
    //     'centa_standard_id',
    //     { centa_standard: ['name'] },
    //     'strand_id',
    //     { strands: ['name'] },
    //     { taxonomy: ['id', 'name'] },
    //     'competency_id',
    //     { competencies: ['name'] },

    //     // { paperWorkRequestGrades: ['id', 'grade_id', { grade: ['name'] }] },
    //     { userByCreatorId: ['id', 'displayName'] },
    //     // { paperWorkRequestReviewers: ['id', 'user_id', { userByReviewerId: ['displayName', 'id'] }] },
    //     // {
    //     //   paperWorkRequestApprovers: [
    //     //     'id',
    //     //     'approver_id',
    //     //     { userByApprover: ['displayName', 'id'] },
    //     //     'reviewer_id',
    //     //     { userByReviewerId: ['displayName', 'id'] },
    //     //   ],
    //     // },
    //     // { userByReviewerId: ['id', 'displayName'] }, { userByApproverId: ['id', 'displayName'] }
    //   ],
    // },
    { paper: ['id', 'paper_id', 'paper_smart_id'] },
    'paper_id',
    // 'cloned_from',
    // 'clone',
    'qb_permit',
    {
      variant_questions: [
        'id',
        'work_request_id',
        'reviewer_stem_comments',
        'approver_stem_comments',
        'parent_question_id',
        'question_insight',
        'status',
        'second_reviewer_id',
        'second_approver_id',
        'second_reviewer_comments',
        'second_approver_comments',
        { parent_question: ['id', 'question_id', 'title'] },
        {
          work_request: [
            'id',
            'name',
            'request_id',
            'request_type',
            'status',
            'created_by',
            ,
            { topic: ['name'] },
            'subject_id',
            { subject: ['name'] },
            'theme_id',
            { theme: ['name'] },
            'sub_theme_id',
            { sub_theme: ['name'] },
            'report_theme_id',
            { report_theme: ['name'] },
            'question_type_id',
            { question_type: ['name'] },
            'teacher_level_id',
            { teacher_level: ['name'] },
            'bloom_level_id',
            { bloom_level: ['name'] },
            'difficulty_level_id',
            { difficulty_levels: ['name'] },
            'centa_standard_id',
            { centa_standard: ['name'] },
            'strand_id',
            { strands: ['name'] },
            { taxonomy: ['id', 'name'] },
            'competency_id',
            { competencies: ['name'] },

            { workRequestGrades: ['id', 'grade_id', { grade: ['name'] }] },
            { userByCreatorId: ['id', 'displayName'] },
            { workRequestReviewers: ['id', 'user_id', { userByReviewerId: ['displayName', 'id'] }] },
            {
              workRequestApprovers: [
                'id',
                'approver_id',
                { userByApprover: ['displayName', 'id'] },
                'reviewer_id',
                { userByReviewerId: ['displayName', 'id'] },
              ],
            },
            // { userByReviewerId: ['id', 'displayName'] }, { userByApproverId: ['id', 'displayName'] }
          ],
        },
        'description',
        'title',
        'question',
        'question_type_id',
        'request_type',
        'user_type',

        { question_type: ['name'] },
        'explanation_type_id',
        { explanation_type: ['name'] },
        'grade_id',
        { grade: ['name'] },
        'subject_id',
        { subject: ['name'] },
        'theme_id',
        { theme: ['name'] },
        'sub_theme_id',
        { sub_theme: ['name'] },
        'report_theme_id',
        { report_theme: ['name'] },
        'topic_id',
        { topic: ['name'] },

        'creator_id',
        { userByCreatorId: ['displayName'] },
        'reviewer_id',
        { userByReviewerId: ['displayName'] },
        'approver_id',
        { userByApproverId: ['displayName'] },
        'question_id',
        'status',
        'option_details',
        'option_type',
        'teacher_level_id',
        { teacher_level: ['name'] },
        'bloom_level_id',
        { bloom_level: ['name'] },
        'difficulty_level_id',
        { difficulty_level: ['name'] },
        'competency_id',
        { competencies: ['name'] },
        // 'competency_aspect_id',
        // { competency_aspect: ['name'] },
        'centa_standard_id',
        { centa_standard: ['name'] },
        'strand_id',
        { strand: ['name'] },
        'centa_concept_id',
        { centa_concept: ['name'] },
        'tn_taxonomy_id',
        { tn_taxonomy: ['name'] },
        'created_at',
        'created_by',
        { user: ['displayName'] },
        'updated_at',
        'updated_by',
        'mark_retired_reasons',
        'mark_retired_comments',
        'grade_ids',
        { question_grades: ['id', 'grade_id', { grade: ['name'] }] },
      ],
    },
  ],
}

export default metaData
